import React from 'react';

import Aux from 'hoc/ReactAux/ReactAux';

const PickOutOptions = props => {
  return (
    <div className={'pick-out'}>
      {props.productSelected.mealOptions.map((mealOption, index) => (
        <Aux key={index}>
          <div className={'choice'} tabIndex={0}>
            <h4>
              <b>{mealOption.name}</b>
              {mealOption.itemMaxQuantity
                ? '(Choose max ' + mealOption.itemMaxQuantity + ' )'
                : ''}
            </h4>
            <p style={{ color: 'var(--lt-color-danger)', marginTop: '10px' }}>
              {mealOption.flagRequired === 'Y'
                ? 'You should select at least 1'
                : ''}
            </p>
            {mealOption.mealOptionItens.map((item, index) => (
              <Aux key={item.id}>
                <input
                  onChange={evt =>
                    props.selectMealOptions(
                      evt,
                      mealOption.idCategoryType,
                      item.id
                    )
                  }
                  type="checkbox"
                  id={item.name + mealOption.idCategoryType + item.id}
                  className="border-black singup"
                  name={mealOption.name + item.id}
                  checked={
                    !!props.mealOptionsSelected.find(selected => {
                      return (
                        selected.idCategoryType === mealOption.idCategoryType &&
                        selected.idMealOption === item.id
                      );
                    })
                  }
                />
                <label
                  style={item.outOfStock ? { color: 'var(--lt-color-muted-foreground)' } : {}}
                  className="singup "
                  htmlFor={item.name + mealOption.idCategoryType + item.id}
                >
                  <b>{item.name}</b>
                  {item.price !== null && item.price !== 0
                    ? '+ ' + item.price.toFixed(2)
                    : null}
                  {item.outOfStock ? (
                    <div>
                      <small class="right">It is out of stock</small>
                    </div>
                  ) : null}
                </label>
              </Aux>
            ))}
          </div>
        </Aux>
      ))}
    </div>
  );
};

export default PickOutOptions;



// WEBPACK FOOTER //
// ./src/containers/Menu/MenuComponents/Products/ProductDetails/PickOutOptions.js